import React from 'react'
import LogoQualy from './LogoQualy'
import { Container, Spinner } from 'react-bootstrap'

function Loading() {
    return (
        <>
            <div
                className="d-flex justify-content-center align-items-center vh-100"
                style={{ textAlign: "center" }}
            >
                <div>
                    <LogoQualy className="w-100" />

                    <div className="mt-3">
                        <Spinner animation="border" />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Loading